import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FaGithub, FaYoutube, FaLinkedin, FaInstagram, FaTwitter } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="bg-dark py-3 position-relative">
      <Container>
        <Row className="justify-content-center align-items-center">
          <Col xs="auto">
            <a href="https://github.com/aryanxk02"><FaGithub size={30} /></a>
          </Col>
          <Col xs="auto">
            <a href="https://www.youtube.com/c/CuriousAryan"><FaYoutube size={30} /></a>
          </Col>
          <Col xs="auto">
            <a href="https://www.linkedin.com/in/aryan-kenchappagol/"><FaLinkedin size={30} /></a>
          </Col>
          <Col xs="auto">
            <a href="https://www.instagram.com/aryan.kx/"><FaInstagram size={30} /></a>
          </Col>
          <Col xs="auto">
            <a href="https://twitter.com/aryan_kx"><FaTwitter size={30} /></a>
          </Col>
        </Row>
        <Row className="justify-content-center align-items-center">
          <Col className="text-center mt-3">
            <p>&copy; {new Date().getFullYear()} ✨ Aryan Kenchappagol ✨</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
